<template>
  <div v-if="show" class="w-full flex flex-col gap-2">
    <div class="flex justify-between">
      <h3 style="color: var(--titulo)">{{ form_title }}</h3>
      <div>
        <AppButton
          v-bind:visibility="true"
          left_icon="fa-regular fa-circle-xmark fa-xl"
          emitType="close"
          @close="close"
          :width="20"
          :height="20"
        />
      </div>
    </div>
    <div class="w-full flex flex-wrap gap-2">
      <div class="flex justify-center gap-4">
        <div v-if="isPerfilView" class="flex items-center gap-2">
          <label for="nome" style="color: var(--label)">Nome:</label>
          <input
            type="text"
            v-model="perfilCopy.nome"
            placeholder="Nome"
            class="rounded-md p-1 outline-none"
            :class="{ 'input-required': !perfilCopy.nome }"
            required
          />
        </div>
        <div v-if="isPerfilView" class="flex items-center gap-2">
          <label for="descricao" style="color: var(--label)">Descrição:</label>
          <input
            type="text"
            v-model="perfilCopy.descricao"
            placeholder="Descrição"
            class="rounded-md p-1 outline-none"
            :class="{ 'input-required': !perfilCopy.descricao }"
            required
          />
        </div>
        <div v-if="selectedPermissao" class="flex text-[var(--text)]">
          <div class="flex gap-2 justify-center">
            <div
              v-for="(value, operation) in selectedPermissao.selectedOperations"
              :key="operation"
              class="flex gap-2 justify-center items-center"
            >
              <input
                type="checkbox"
                :id="selectedPermissao.id + operation + 'Checkbox'"
                v-model="selectedPermissao.selectedOperations[operation]"
                @change="updateAutorizacao(selectedPermissao, $event)"
                class="text-blue-500"
              />
              <label :for="selectedPermissao.id + operation + 'Checkbox'">{{
                operation
              }}</label>
            </div>
          </div>
        </div>
      </div>
      <div class="flex justify-center gap-2 p-1 text-nowrap">
        <button
          class="bg-[var(--button)] text-[var(--text)] rounded-md px-2 py-1 hover:bg-[var(--icon)]"
          @click="selectAll"
        >
          Selecionar tudo
        </button>
        <button
          class="bg-[var(--button)] text-[var(--text)] rounded-md px-2 py-1 hover:bg-[var(--icon)]"
          @click="deselectAll"
        >
          Descartar tudo
        </button>
        <button
          v-if="isPerfilView"
          class="bg-[var(--button)] text-[var(--text)] rounded-md px-2 py-1 hover:bg-[var(--icon)]"
          @click="buttonAction"
        >
          {{ buttonText }}
        </button>
        <button
          v-if="!isPerfilView"
          class="bg-[var(--button)] text-[var(--text)] rounded-md px-2 py-1 hover:bg-[var(--icon)]"
          @click="showPerfis"
        >
          Mostrar Perfis
        </button>
      </div>
    </div>
    <p
      class="error-message text-center text-red-400"
      v-if="errorMessage && isPerfilView"
    >
      {{ errorMessage }}
    </p>
    <div class="flex w-full text-[var(--text)]">
      <div
        class="cursor-pointer hover:text-gray-400"
        @click="chevronClicked('left')"
      >
        <i class="fa-solid fa-chevron-left"></i>
      </div>
      <div
        class="grid sm:grid-cols-3 md:grid-cols-6 lg:grid-cols-9 gap-0.5 flex-grow transition-all duration-500"
      >
        <div
          v-for="(item, index) in paginatedItems"
          :key="index"
          class="cursor-pointer text-sm text-center text-wrap px-2 py-1 rounded-md bg-[var(--button)] hover:bg-[var(--icon)] truncate"
          :class="{ 'bg-[var(--icon)]': selectedItem === item }"
          @click="itemClicked(item)"
        >
          {{ item }}
        </div>
      </div>

      <div
        class="cursor-pointer hover:text-gray-400"
        @click="chevronClicked('right')"
      >
        <i class="fa-solid fa-chevron-right"></i>
      </div>
    </div>
    <div v-if="selectedItem && permissoes.length > 0" class="text-[var(--text)]">
        <GenericDataTable
          ref="genericTable"
          :tableData="permissoes"
          :columns="permissoesColumns"
          api-url="dummy"
          :useServerSide="false"
          :show_export="false"
          :show_close_btn="false"
          :table_title="`${table_title}`"
          scroll-y="50vh"
          :selectable="true"
          selection-mode="single"
          v-model:selected-rows="selectedPermissoesArray"
          @selection-changed="handlePermissaoSelection"
        />
    </div>
    <div v-else class="p-2 text-center text-red-300">
      No permissions for this item.
    </div>
  </div>
</template>

<script>
import AppButton from "@/components/updated/button.vue";
import AppPermissionsTable from "@/components/perfil/perfilTable.vue";
import GenericDataTable from "@/components/dataTable/GenericDataTable2.vue";
import { toast } from "vue3-toastify";

export default {
  name: "AppPerfilForm",
  components: {
    AppButton,
    AppPermissionsTable,
    GenericDataTable,
  },
  data() {
    return {
      user: null,
      perfilCopy: {},
      perfil: {},
      perfilGeral: {},
      selectedPermissoes: [],
      permissoes: [],
      filter: [],
      show_table: true,
      table_title: "",
      selectedPermissao: null,
      selectedAutorizacao: null,
      status: "ativo",
      show: false,
      errorMessage: "",
      selectedItem: null,
      allSelected: false,
      noneSelected: true,
      selectorText: "",
      selectedPermissions: {},
      currentPage: 0,
      itemsPerPage: 9,
      selectedPermissoesArray: [],
      items: [
        "Dashboard",
        "Análise Técnico",
        "Análise Estatística",
        "Configurações",
        "Roles",
        "Utilizadores",
        "Clientes",
        "Fornecedores",
        "Negocios Extra",
        "Stocks",
        "Armazens",
        "Viaturas",
        "Familias",
        "Equipamentos",
        "Negocios",
        "Artigos",
        "Planeamento",
        "Notificar Serviço",
        "Ordem Serviço",
        "Correção Técnico",
        "Documentção",
        "Tabela-Preço",
        "Contactos",
        "Histórico",
        "Pesquisa Artigos",
        "Novidades",
        "Dashboard-TC",
        "Planeamento-TC",
        "Stock-TC",
        "Contactos-TC",
        "Serviços-TC",
        "Instalação-TC",
        "Execuções-TC",
      ],
      showCheckboxes: false,
      // GenericDataTable columns definition
      permissoesColumns: [
        { label: "Código", key: "codigo", sortable: true, width: 80 },
        { label: "Tipo", key: "tipo", sortable: true, maxWidth: 120 },
        { label: "Permissão", key: "permissao", sortable: true, maxWidth: 200 },
        {
          label: "Autorização",
          key: "autorizacao",
          sortable: false,
          maxWidth: 90,
        },
      ],
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    formData: {
      type: Object,
      default: {},
    },
    form_title: {
      type: String,
      default: "",
    },
    isPerfilView: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    formData: {
      handler(newData) {
        // Verifica si formData tiene datos válidos
        if (newData && newData.permissao) {
          // Clona formData para inicializar perfilCopy
          this.perfilCopy = JSON.parse(JSON.stringify(newData));
          if (this.form_title === "Criar Perfil") {
            this.perfilCopy.nome = "";
            this.perfilCopy.descricao = "";
          }

          this.perfilCopy.permissao.forEach((permissao) => {
            const operationLabels = {
              L: "List",
              R: "Read",
              C: "Create",
              V: "View",
            };
            permissao.selectedOperations = {};
            if (!permissao.mascara) {
              console.warn(
                `permissao.mascara is missing for permissao id: ${permissao.id}`
              );
              permissao.mascara = "";
            }
            if (!permissao.autorizacao) {
              console.warn(
                `permissao.autorizacao is missing for permissao id: ${permissao.id}`
              );
              permissao.autorizacao = "";
            }

            for (let i = 0; i < permissao.mascara.length; i++) {
              const operation = permissao.mascara[i];
              const vals = permissao.autorizacao[i];
              const label = operationLabels[operation];
              const valor = operationLabels[vals];
              if (valor) {
                permissao.selectedOperations[valor] = true;
              } else {
                permissao.selectedOperations[label] = false;
              }
            }
          });
          this.itemClicked(this.items[0]);
        }
      },
      immediate: true,
      deep: true,
    },
    selectedPermissoes: {
      handler(newPermissoes, oldPermissoes) {
        newPermissoes.forEach((permissao, index) => {
          if (
            oldPermissoes[index] &&
            permissao.selectedOperations !==
              oldPermissoes[index].selectedOperations
          ) {
            permissao.autorizacao = Object.entries(permissao.selectedOperations)
              .filter(([operation, isSelected]) => isSelected)
              .map(([operation]) => operation.charAt(0).toUpperCase())
              .join("");
          }
        });
      },
      deep: true,
    },
    "selectedPermissoes[].mascara": {
      handler(newVal, oldVal) {
        this.updateCheckboxState();
      },
      deep: true,
    },
    "selectedPermissoes[].autorizacao": {
      handler(newVal, oldVal) {
        this.updateCheckboxState();
      },
      deep: true,
    },
    perfilCopy: {
      deep: true,
      handler(newValue, oldValue) {
        this.$emit("perfilCopyChanged", newValue);
      },
    },
  },
  computed: {
    visibleItems() {
      return this.items.slice(this.startIndex, this.startIndex + 9);
    },
    itemsSet() {
      return this.items.length > 0;
    },
    paginatedItems() {
      const start = this.currentPage * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.items.slice(start, end);
    },
    selectedPermissoes() {
      return this.permissoes.filter((permissao) => permissao.isSelected);
    },
    isCheckboxSelected() {
      return (
        this.selectedPermissao.mascara && this.selectedPermissao.autorizacao
      );
    },
    buttonText() {
      return this.form_title === "Criar Perfil" ? "Criar" : "Atualizar";
    },
  },
  methods: {
    showMessage(tipo, message) {
      if (tipo === "error") {
        toast.error(message, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
      } else if (tipo === "success") {
        toast.success(message, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
      } else if (tipo === "warning") {
        toast.warning(message, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
      }
    },
    updateCheckboxState() {
      this.selectedPermissoes.forEach((permissao) => {
        const isSelected = Boolean(permissao.mascara && permissao.autorizacao);
        for (const operation in permissao.selectedOperations) {
          permissao.selectedOperations[operation] = isSelected;
        }
      });
    },
    chevronClicked(direction) {
      if (direction === "right") {
        this.nextPage();
      } else if (direction === "left") {
        this.prevPage();
      }
    },
    nextPage() {
      if ((this.currentPage + 1) * this.itemsPerPage < this.items.length) {
        this.currentPage++;
      }
    },
    prevPage() {
      if (this.currentPage > 0) {
        this.currentPage--;
      }
    },

    handlePermissaoSelection(selectedRows) {
      // Handle selection from GenericDataTable (DataTables selection plugin)
      if (selectedRows && selectedRows.length > 0) {
        const permissao = selectedRows[0]; // Single selection mode

        // Create selectedOperations object for the clicked permission only if it doesn't exist
        if (!permissao.selectedOperations) {
          const operationLabels = {
            L: "List",
            R: "Read",
            C: "Create",
            V: "View",
          };
          permissao.selectedOperations = {};
          for (let i = 0; i < permissao.mascara.length; i++) {
            const operation = permissao.mascara[i];
            const label = operationLabels[operation];
            if (label) {
              permissao.selectedOperations[label] =
                permissao.autorizacao.includes(operation);
            }
          }
        }

        this.selectedPermissao = permissao;
        this.showCheckboxes = true;
      } else {
        // No selection
        this.selectedPermissao = null;
        this.showCheckboxes = false;
      }
    },

    permissaoClicked(permissao) {
      // Deselect all other permissions
      this.permissoes.forEach((p) => {
        if (p !== permissao) {
          p.isSelected = false;
        }
      });

      // Toggle isSelected property of the clicked permission
      permissao.isSelected = !permissao.isSelected;

      // Create selectedOperations object for the clicked permission only if it doesn't exist
      if (permissao.isSelected && !permissao.selectedOperations) {
        const operationLabels = {
          L: "List",
          R: "Read",
          C: "Create",
          V: "View",
          // Add more mappings as needed
        };
        permissao.selectedOperations = {};
        for (let i = 0; i < permissao.mascara.length; i++) {
          const operation = permissao.mascara[i];
          const label = operationLabels[operation];
          if (label) {
            permissao.selectedOperations[label] =
              permissao.autorizacao.includes(operation);
          }
        }
      }


      // Show checkboxes only when a permission is selected
      this.selectedPermissao = permissao;
      this.showCheckboxes = this.permissoes.some((p) => p.isSelected);
    },
    
   
    itemClicked(item) {
      this.selectedItem = item;
      this.showCheckboxes = true;
      // Filter permissoes based on the clicked item
      this.permissoes = this.perfilCopy.permissao.filter((permissao) => {
        return permissao.tema === item;
      });
      this.selectedPermissao = this.permissoes[0].isSelected;
      this.table_title = this.permissoes[0].tema;
    },
    updateAutorizacao(permissao, event) {
      if (event.target.type === "checkbox") {
        let autorizacao = "";
        for (const key in permissao.selectedOperations) {
          if (permissao.selectedOperations[key]) {
            autorizacao += key.charAt(0).toUpperCase();
          }
        }
        permissao.autorizacao = autorizacao;

        // Find the corresponding permissao in the perfilCopy.permissao array by id and update its autorizacao
        const permissaoInPerfilCopy = this.perfilCopy.permissao.find(
          (p) => p.id === permissao.id
        );
        if (permissaoInPerfilCopy) {
          permissaoInPerfilCopy.autorizacao = autorizacao;
        }
      }
    },
    close() {
      this.$emit("close");
    },
    showPerfis() {
      this.$emit("showPerfis");
    },
    buttonAction() {
      if (this.form_title === "Criar Perfil") {
        this.createPerfil();
      } else {
        this.updatePerfil();
      }
    },
    selectAll() {
      for (const permissao of this.permissoes) {
        permissao.autorizacao = "";
        for (const key in permissao.selectedOperations) {
          permissao.selectedOperations[key] = true;
          permissao.autorizacao += key.charAt(0).toUpperCase();
        }
      }
      this.allSelected = true;
      this.noneSelected = false;
     
    },
    deselectAll() {
      for (const permissao of this.permissoes) {
        permissao.autorizacao = "";
        for (const key in permissao.selectedOperations) {
          permissao.selectedOperations[key] = false;
        }
 
      }
      this.allSelected = false;
      this.noneSelected = true;
    },

    createPerfil() {
      // Lógica para crear un perfil
      if (!this.perfilCopy.nome || !this.perfilCopy.descricao) {
        this.showMessage("warning", "Preencha todos os campos");
        return;
      }

      const perfil = {
        nome: this.perfilCopy.nome,
        descricao: this.perfilCopy.descricao,
        utilizador_id: this.perfilCopy.utilizador_id,
        permissao: this.perfilCopy.permissao,
      };
      this.$emit("submit", { data: perfil });
      // this.perfilCopy = formData;
    },

    updatePerfil() {
      // Lógica para actualizar un perfil
      if (!this.perfilCopy.nome || !this.perfilCopy.descricao) {
        // this.errorMessage = 'All fields are required';
        this.showMessage("warning", "Preencha todos os campos");
        return;
      }

      const perfil = {
        id: this.perfilCopy.id,
        nome: this.perfilCopy.nome,
        descricao: this.perfilCopy.descricao,
        utilizador_id: this.perfilCopy.utilizador_id,
        permissao: this.perfilCopy.permissao,
      };
      this.$emit("update", { data: perfil });
      this.perfilCopy = {};
    },
  },
};
</script>
<style scoped>
.text-white {
  color: var(--label);
}
</style>
